import { render, staticRenderFns } from "./DeletePassword.vue?vue&type=template&id=18f8a2a4&scoped=true"
import script from "./DeletePassword.vue?vue&type=script&lang=js"
export * from "./DeletePassword.vue?vue&type=script&lang=js"
import style0 from "./DeletePassword.vue?vue&type=style&index=0&id=18f8a2a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f8a2a4",
  null
  
)

export default component.exports